// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-424970e6]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:10px}.header[data-v-424970e6],.left-side[data-v-424970e6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.header-text[data-v-424970e6]{font-size:18px;font-weight:500;margin-left:10px}.actions[data-v-424970e6],.icon[data-v-424970e6]{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
// Exports
module.exports = exports;
